import { t } from '@/features/i18n/utils';
import { useWorkspace } from '@/features/workspaces/helpers';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Icon } from '@/ui/components/icon';
import { FolderIcon } from '@hugeicons-pro/core-stroke-rounded';
import { WorkspaceBreadcrumbs } from '@/features/workspaces/components/workspace-breadcrumbs';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { HeaderBackButton, HeaderChatButton, Header } from '@/ui/components/header';
import { MainHeader, MainHeaderBackButton, MainScrollArea } from '@/ui/components/main';
import { H1 } from '@/ui/components/heading';
import { FilesPageList } from '@/features/documents/components/files-page/files-page-list';
import {
  FilesPageAddFilesButton,
  FilesPageCount,
} from '@/features/documents/components/files-page/files-page-header';
import { FileUploadDialog } from '@/features/documents/components/file-upload';
import { IndexingStatusAlerts } from '@/features/documents/components/indexing-status-alerts';
export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/files/',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const { workspaceId, projectId } = Route.useParams();
  const workspace = useWorkspace();

  return (
    <>
      <Header>
        <HeaderBackButton />
        <WorkspaceBreadcrumbs>
          <BreadcrumbPage>
            <Icon icon={FolderIcon} />
            {t({ en: 'Files', nb: 'Filer' })}
          </BreadcrumbPage>
        </WorkspaceBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <MainScrollArea>
        <IndexingStatusAlerts resourceId={workspaceId} documentType={workspace.type} />
        <MainHeader>
          <H1>
            <MainHeaderBackButton
              to="/project/$projectId/workspaces/$workspaceId"
              params={{ projectId, workspaceId }}
            />
            {t({ en: 'Files', nb: 'Filer' })}
            <FilesPageCount resourceId={workspaceId} resourceType={workspace.type} />
          </H1>
          <FilesPageAddFilesButton resourceId={workspaceId} resourceType={workspace.type} />
        </MainHeader>
        <FilesPageList
          resourceId={workspaceId}
          resourceType={workspace.type}
          onRowClick={(doc) => {
            navigate({
              to: '/project/$projectId/workspaces/$workspaceId/files/$documentId',
              params: { projectId, workspaceId, documentId: doc.id },
            });
          }}
        />
      </MainScrollArea>
      <FileUploadDialog resourceId={workspaceId} resourceType={workspace.type} />
    </>
  );
}
